import styled from 'styled-components';

import ButtonComponent from 'dc/Button';
import PoM000 from 'dc/PoM000';
import Spa16 from 'dc/Spa16';
import { Typ30 } from 'dc/Typ';
import Ico20 from 'dc/Ico20';

export const ComponentWrapper = styled('div')`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin: 0;
  padding: 0;
`;

type PopoverProps = {
  $popupPosition: string;
  $expanded: boolean;
};

export const Popover = styled(PoM000)<PopoverProps>`
  position: absolute;
  left: ${props =>
    props.$popupPosition.indexOf('left') !== -1 ? '-126px' : '0px'};
  top: ${props =>
    props.$popupPosition.indexOf('below') !== -1 ? '36px' : '-112px'};
  background: #ffffff;
  width: 200px;
  display: ${props => (props.$expanded ? 'flex' : 'none')};
  flex-direction: column;
  align-items: stretch;
`;

export const Button = styled(ButtonComponent)`
  & > i {
    color: #455a64;
  }
  &:hover > i {
    color: #007079;
  }
`;

export const Spacer = styled(Spa16)`
  background: transparent;
`;

type WrapperProps = {
  $selected?: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  background-color: ${props => (props.$selected ? '#ECEFF1' : 'transparent')};
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  &:hover {
    background-color: #eceff1;
  }
  max-width: 100%;
  padding: 12px 16px;
`;
export const Text = styled(Typ30)`
  margin-right: 16px;
`;

type IconProps = {
  $selected?: boolean;
};

export const Icon = styled(Ico20)<IconProps>`
  margin-right: 16px;
  visibility: ${props => (props.$selected ? 'visible' : 'hidden')};
`;

export const List = styled.ul`
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
`;

export const ListItem = styled.li`
  list-style: none;
  display: flex;
  flex-direction: column;
`;
